export default __webpack_public_path__ + "static/media/24.4efa794c.gif";